import { FileSpreadsheet, FileText, Cloud, CalendarClock, AlertTriangle, Layers, BellRing, PackageCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const today = [
  { icon: FileSpreadsheet, text: "Excel sheets" },
  { icon: FileText, text: "PDFs" },
  { icon: Cloud, text: "Cloud folders" },
  { icon: CalendarClock, text: "Chasing expiry dates" },
  { icon: AlertTriangle, text: "Scrambling before inspections" },
];

const after = [
  { icon: Layers, text: "One place" },
  { icon: BellRing, text: "Alerts before anything expires" },
  { icon: PackageCheck, text: "An inspection pack ready in one click" },
];

const tilts = ["-rotate-2", "rotate-1", "-rotate-1", "rotate-2", "-rotate-1"];

export const BeforeAfter = () => (
  <section data-testid="before-after-section" className="bg-[#F9FAFC] px-6 py-24 md:px-10 md:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <Eyebrow>Before &amp; after</Eyebrow>
        <h2 className="mt-5 max-w-3xl font-display text-4xl leading-[1.05] tracking-tight text-[#0B192C] md:text-6xl">
          Stop chasing paper. <span className="italic text-[#C87D55]">Start ready.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-6 lg:grid-cols-2">
        <Reveal className="h-full">
          <div data-testid="today-chaos-card" className="h-full rounded-[28px] border border-dashed border-slate-300 bg-white p-8 md:p-12">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-600">Today</p>
            <ul className="mt-10 flex flex-wrap gap-3">
              {today.map(({ icon: Icon, text }, i) => (
                <li key={text} className={`flex items-center gap-2.5 rounded-full border border-slate-200 bg-slate-50 px-4 py-2.5 text-slate-600 transition-transform duration-300 hover:rotate-0 ${tilts[i]}`}>
                  <Icon className="h-4 w-4 shrink-0 text-slate-500" />
                  <span className="text-sm md:text-base">{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="h-full">
          <div data-testid="marineos-solution-card" className="relative h-full overflow-hidden rounded-[28px] bg-[#0B192C] p-8 text-[#F4EDE3] md:p-12">
            <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-[#C87D55]/25 blur-3xl" />
            <p className="relative font-mono text-xs uppercase tracking-[0.25em] text-[#D4A373]">With MarineOS</p>
            <ul className="relative mt-10 space-y-6">
              {after.map(({ icon: Icon, text }) => (
                <li key={text} className="group flex items-center gap-5">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#C87D55]/60 transition-colors duration-300 group-hover:bg-[#C87D55]">
                    <Icon className="h-5 w-5 text-[#D4A373] transition-colors duration-300 group-hover:text-[#0B192C]" />
                  </span>
                  <span className="font-display text-2xl leading-tight md:text-3xl">{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
